module.exports = __webpack_public_path__ + "img/hatakaku.e31e854.png";